module.exports = __webpack_public_path__ + "static/work6-8432c9fe4ddc80828b40f9143c9e40ae.jpg";